<div class="container">
    <div class="my-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a [routerLink]="APP_ROUTES.INDEX">{{ NAVS.INDEX }}</a></li>
                <li class="breadcrumb-item active"
                    aria-current="page">{{ template?.data.page?.breadcrumb || NAVS.PRIVACY.INDEX }}
                </li>
            </ol>
        </nav>
    </div>

    <h1 class="mb-3">{{ template?.data.page?.h1 || NAVS.PRIVACY.INDEX }}</h1>

    <section class="mb-4">
        <p>
            Настоящая Политика обработки персональных данных определяет порядок обработки и защиты персональных данных,
            которые MotorDesk получает при использовании сайта {{ env.URL_FRONT }}, личного кабинета, демо-режима,
            регистрационных форм, средств обратной связи и связанных интеграций сервиса.
        </p>
        <p>
            Политика применяется к данным посетителей сайта, зарегистрированных пользователей, пользователей личного
            кабинета и лиц, добровольно взаимодействующих с сервисом через интеграции, включая Telegram-бота.
        </p>
    </section>

    <section class="mb-4">
        <h2>1. Оператор персональных данных</h2>
        <p>
            Оператором персональных данных является MotorDesk. По вопросам, связанным с обработкой персональных данных,
            пользователь может обратиться по адресу электронной почты admin&#64;motordesk.ru.
        </p>
    </section>

    <section class="mb-4">
        <h2>2. Какие данные могут обрабатываться</h2>
        <p>В зависимости от сценария использования сервиса Оператор может обрабатывать следующие категории данных:</p>
        <ul>
            <li><b>Данные посетителя сайта:</b> IP-адрес, cookie, идентификаторы сессии, дата и время доступа, адреса
                посещенных страниц, технические данные браузера, устройства и операционной системы, а также иные
                стандартные данные веб-запросов и серверных журналов.
            </li>
            <li><b>Данные регистрации и аккаунта:</b> адрес электронной почты, имя пользователя, учетные идентификаторы,
                данные, необходимые для аутентификации, восстановления доступа, подтверждения регистрации и поддержки
                аккаунта.
            </li>
            <li><b>Данные, вводимые пользователем в сервис:</b> сведения об автомобилях, пробеге, заправках, расходах,
                доходах, сервисной истории, плановых работах, сервисных точках, контактных данных сервисных организаций
                и иные сведения, которые пользователь самостоятельно вносит в личный кабинет.
            </li>
            <li><b>Данные взаимодействия с поддержкой:</b> содержание обращений, сообщения, приложенные сведения, дата и
                время обращения, технические данные, необходимые для рассмотрения запроса.
            </li>
            <li><b>Данные интеграций:</b> идентификаторы и технические данные, необходимые для связи аккаунта
                пользователя с внешними сервисами, включая Telegram-бота, если пользователь добровольно использует такую
                интеграцию.
            </li>
            <li><b>Обезличенные и статистические данные:</b> агрегированные сведения о работе сервиса, действиях
                пользователей, нагрузке, ошибках, производительности и востребованности функций.
            </li>
        </ul>
        <p>
            Оператор не требует от пользователя предоставления избыточных данных и исходит из того, что пользователь
            вводит в сервис только те сведения, которые считает необходимыми для собственных целей использования
            сервиса.
        </p>
    </section>

    <section class="mb-4">
        <h2>3. Цели обработки персональных данных</h2>
        <p>Персональные данные могут обрабатываться для следующих целей:</p>
        <ul>
            <li>регистрация пользователя, создание и сопровождение аккаунта;</li>
            <li>предоставление доступа к функциям сайта, демо-режима, личного кабинета и интеграций сервиса;</li>
            <li>аутентификация пользователя, подтверждение действий, восстановление доступа и обеспечение безопасности
                аккаунта;
            </li>
            <li>хранение, отображение, систематизация и обработка данных, которые пользователь вносит в сервис для учета
                автомобиля;
            </li>
            <li>направление сервисных уведомлений, сообщений о безопасности, подтверждения регистрации, инструкций по
                доступу, ответов на обращения и иной значимой информации о работе сервиса;
            </li>
            <li>обработка обращений пользователей, разрешение инцидентов, техническая поддержка и улучшение клиентского
                опыта;
            </li>
            <li>предотвращение злоупотреблений, несанкционированного доступа, мошенничества, атак и иных действий,
                угрожающих сервису и пользователям;
            </li>
            <li>развитие, тестирование, администрирование и улучшение функциональности сервиса;</li>
            <li>исполнение обязанностей, предусмотренных применимым законодательством, а также защита прав и законных
                интересов Оператора.
            </li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>4. Правовые основания обработки</h2>
        <p>Оператор обрабатывает персональные данные на следующих основаниях:</p>
        <ul>
            <li>согласие субъекта персональных данных, когда такое согласие требуется;</li>
            <li>необходимость исполнения Соглашения и предоставления пользователю доступа к сервису и его функциям;</li>
            <li>необходимость выполнения обязанностей, возложенных на Оператора законодательством;</li>
            <li>законные интересы Оператора, в том числе обеспечение работоспособности, безопасности, развития и защиты
                сервиса, если при этом не нарушаются права и свободы субъекта персональных данных.
            </li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>5. Условия обработки и передачи данных</h2>
        <ul>
            <li>Обработка персональных данных может осуществляться с использованием средств автоматизации, без
                использования таких средств либо смешанным способом.
            </li>
            <li>Доступ к персональным данным предоставляется только тем лицам и в том объеме, которым он объективно
                необходим для работы сервиса, исполнения обязанностей Оператора, технической поддержки и обеспечения
                безопасности.
            </li>
            <li>Оператор вправе привлекать третьих лиц и поставщиков сервисов, необходимых для функционирования проекта,
                включая хостинг, электронную почту, защиту от автоматизированных запросов, связь, техническую
                инфраструктуру, аналитику, журналы ошибок и иные вспомогательные решения.
            </li>
            <li>Если пользователь добровольно подключает внешнюю интеграцию, включая Telegram-бота, часть данных,
                необходимых для работы такой интеграции, может обрабатываться соответствующим внешним сервисом на его
                условиях и по его политике конфиденциальности.
            </li>
            <li>Оператор вправе передавать персональные данные третьим лицам в случаях, когда это требуется по закону,
                необходимо для защиты прав и законных интересов Оператора, необходимо для работы сервиса либо
                осуществляется с согласия пользователя.
            </li>
            <li>Оператор не делает недостоверных обещаний об абсолютном отсутствии передачи данных третьим лицам,
                поскольку часть обработки объективно может осуществляться через инфраструктурных и технологических
                подрядчиков.
            </li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>6. Данные третьих лиц, вводимые пользователем</h2>
        <p>
            Пользователь может самостоятельно вносить в сервис сведения, которые прямо или косвенно относятся к третьим
            лицам, например контакты сервисных организаций, телефоны, адреса и иную информацию.
        </p>
        <p>
            В таких случаях пользователь самостоятельно несет ответственность за законность получения, ввода, хранения
            и использования таких данных в сервисе, включая наличие необходимых согласий и иных правовых оснований.
            Оператор не проверяет автоматически правомерность ввода пользователем данных третьих лиц и исходит из
            добросовестности пользователя.
        </p>
    </section>

    <section class="mb-4">
        <h2>7. Сроки хранения данных</h2>
        <ul>
            <li>Персональные данные хранятся не дольше, чем это необходимо для целей обработки, если более длительный
                срок не требуется по закону или не вытекает из необходимости защиты прав и законных интересов Оператора.
            </li>
            <li>Данные аккаунта и пользовательские записи могут храниться в течение срока существования аккаунта и
                разумного периода после прекращения использования сервиса, если это необходимо для исполнения закона,
                рассмотрения обращений, расследования инцидентов, разрешения споров, защиты прав Оператора или
                восстановления работы сервиса.
            </li>
            <li>Отдельные технические журналы, резервные копии и служебные записи могут храниться дольше
                пользовательского интерфейса удаления, если это обусловлено архитектурой инфраструктуры, обеспечением
                безопасности или требованиями закона.
            </li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>8. Права субъекта персональных данных</h2>
        <p>Пользователь вправе:</p>
        <ul>
            <li>получать сведения об обработке своих персональных данных в пределах, предусмотренных законом;</li>
            <li>требовать уточнения, блокирования или удаления своих персональных данных, если они являются неполными,
                устаревшими, неточными, незаконно полученными или не нужны для заявленной цели обработки;
            </li>
            <li>отозвать согласие на обработку персональных данных, если обработка основана именно на согласии, при этом
                отзыв не влияет на законность обработки, осуществленной до его отзыва;
            </li>
            <li>обращаться к Оператору по вопросам обработки персональных данных по адресу admin&#64;motordesk.ru;</li>
            <li>осуществлять иные права, предусмотренные применимым законодательством.</li>
        </ul>
        <p>
            Запросы субъекта персональных данных должны позволять идентифицировать заявителя и предмет обращения.
            Оператор вправе запросить разумное подтверждение личности и полномочий заявителя.
        </p>
    </section>

    <section class="mb-4">
        <h2>9. Меры по защите данных</h2>
        <p>
            Оператор принимает разумные правовые, организационные и технические меры для защиты персональных данных,
            включая разграничение доступа, применение средств аутентификации, контроль доступа, журналирование событий,
            использование защитных механизмов инфраструктуры, обновление программного обеспечения и иные меры,
            соответствующие характеру обрабатываемых данных и применимым рискам.
        </p>
        <p>
            При этом никакой способ передачи данных через интернет и никакая система хранения данных не могут считаться
            абсолютно безопасными. Оператор не гарантирует абсолютную защищенность данных от всех возможных угроз, но
            принимает разумные меры для снижения соответствующих рисков.
        </p>
    </section>

    <section class="mb-4">
        <h2>10. Cookie и технические данные</h2>
        <p>
            Сайт и связанные разделы сервиса могут использовать cookie, локальное хранилище браузера, сессионные
            идентификаторы и иные технические средства, необходимые для работы интерфейса, авторизации, сохранения
            пользовательских настроек, защиты от злоупотреблений и анализа стабильности сервиса.
        </p>
        <p>
            Пользователь может ограничить использование cookie и отдельных технических средств в настройках браузера,
            однако это может повлиять на доступность и корректность работы части функций сервиса.
        </p>
    </section>

    <section class="mb-4">
        <h2>11. Изменение Политики</h2>
        <p>
            Оператор вправе в любое время изменять настоящую Политику. Новая редакция вступает в силу с момента
            публикации по адресу {{ env.URL_FRONT }}{{ APP_ROUTES.PRIVACY.INDEX }}, если иной срок не указан
            дополнительно.
        </p>
        <p>
            Продолжение использования сервиса после публикации новой редакции Политики означает согласие пользователя
            с ее актуальной редакцией в той части, в которой такое согласие допускается законом.
        </p>
    </section>
</div>
